import React, { Fragment, useEffect, useState } from 'react'
import { Modal, Form, Upload, Button, Input, Row } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { ImageSelect } from '../../../../../components/Form'
import './UploadAudioModal.scss'
import TextEditor from '../TextEditor/TextEditor'
import { PopupMedia } from '../../../../Library/internal'
import _ from 'lodash'
const UploadAudioModal = ({
  t,
  discussionRoomType,
  isUploading,
  audioData,
  open,
  close,
  form,
  onFinish,
  type
}) => {
  const {
    getFieldDecorator,
    validateFields,
    setFieldsValue,
    resetFields
  } = form
  const [editorDescription, setEditorDescription] = useState(
    audioData.description
  )
  const [fileList, setFileList] = useState([])
  const [libraryModal, setLibrayModal] = useState(false)
  const [image, setImage] = useState({ id: '', link: '' })
  useEffect(() => {
    if (audioData.id) {
      setFieldsValue({
        description: audioData.description,
        title: audioData.title,
        cover_id: audioData.cover && audioData.cover.id
      })
      setFileList([
        {
          uid: audioData.filename,
          name: audioData.filename,
          url: audioData.audio_link
        }
      ])
    }
    if (audioData.cover) {
      setImage({ id: audioData.cover.id, link: audioData.cover.link })
    }
  }, [audioData])
  const handleOk = () => {
    if (!editorDescription) {
      setFieldsValue({ description: '' })
    }
    validateFields().then(values => {
      values.description = editorDescription
      values.files = fileList
      onFinish(values)
    })
  }
  const setCoverImage = data => {
    setImage(data)
    setFieldsValue({ cover_id: data.id })
  }
  const handleInsertData = (privateMedia, publicMedia, orgMedia) => {
    let tempData = []
    if (privateMedia) {
      const { rows: privateData } = privateMedia
      privateData.forEach(data => {
        tempData.push(data)
      })
    }

    if (publicMedia) {
      const { rows: publicData } = publicMedia
      publicData.forEach(publicData => {
        tempData.push(publicData)
      })
    }

    if (orgMedia) {
      const { rows: orgData } = orgMedia
      orgData.forEach(orgData => {
        tempData.push(orgData)
      })
    }

    const item = _.head(tempData.filter(value => value.isSelected))
    if (item) {
      const formattedFile = {
        ...item,
        uid: item.id || `${Date.now()}`,
        name: item.originalname || item.filename || 'selected-file.mp3',
        status: 'done',
        isLibraryFile: true
      }
      setFileList([formattedFile])
      setFieldsValue({
        files: [formattedFile]
      })
      setTimeout(() => {
        form.validateFields(['files'], { force: true })
      }, 0)
      setLibrayModal(false)
    }
  }
  const uploadProps = {
    onRemove: file => {
      setFileList(prevFileList =>
        prevFileList.filter(item => item.uid !== file.uid)
      )
      setFieldsValue({ files: [] })
      setTimeout(() => {
        form.validateFields(['files'], { force: true })
      }, 0)
    },
    beforeUpload: file => {
      const fileWithOrigin = {
        ...file,
        uid: file.uid,
        name: file.name,
        status: 'done',
        originFileObj: file // Include the original file object
      }
      const newFileList = [fileWithOrigin]
      setFileList(newFileList)
      setFieldsValue({ files: [file] })
      setTimeout(() => {
        form.validateFields(['files'], { force: true })
      }, 0)
      return false // Prevent automatic upload
    },
    fileList
  }
  return (
    <Modal
      key={'UploadAudioModal'}
      className="uploadmodal-main"
      style={{ position: 'relative', zIndex: 1 }}
      visible={open}
      title={
        discussionRoomType !== 'stories'
          ? type === 'ADD'
            ? t('v4:audio_modal.title_upload')
            : t('v4:audio_modal.title_update') + t('v4:audio_modal.title_audio')
          : type === 'ADD'
          ? t('v4:stories_modal.title_upload')
          : t('v4:stories_modal.title_update') +
            t('v4:stories_modal.title_audio')
      }
      onCancel={close}
      afterClose={() => {
        resetFields()
        setFileList([])
        setImage({ id: '', link: '' })
      }}
      footer={[
        <Fragment>
          <Button loading={isUploading} type="primary" onClick={handleOk}>
            {discussionRoomType !== 'stories'
              ? type === 'ADD'
                ? t('v4:audio_modal.btn_upload')
                : t('v4:audio_modal.btn_update')
              : type === 'ADD'
              ? t('v4:stories_modal.btn_upload')
              : t('v4:stories_modal.btn_update')}
          </Button>
          <Button disabled={isUploading} onClick={close}>
            {discussionRoomType !== 'stories'
              ? type === 'ADD'
                ? t('v4:audio_modal.btn_close')
                : t('v4:audio_modal.btn_cancel')
              : type === 'ADD'
              ? t('v4:stories_modal.btn_close')
              : t('v4:stories_modal.btn_cancel')}
          </Button>
        </Fragment>
      ]}
    >
      <Form layout="vertical">
        <Fragment>
          <Form.Item
            required={false}
            colon={false}
            className="no_bottom_margin"
          >
            {getFieldDecorator('cover_id', {
              initialValue: image.id,
              rules: [
                {
                  required: true,
                  message:
                    discussionRoomType !== 'stories'
                      ? t('v4:audio_modal.rule_cover')
                      : t('v4:stories_modal.rule_cover')
                }
              ]
            })(
              <ImageSelect
                required={false}
                tooltip={t('v4:info_episode')}
                form={form}
                label={
                  discussionRoomType === 'stories'
                    ? t('v4:stories_modal.lbl_cover')
                    : t('v4:audio_modal.lbl_cover')
                }
                coverInput={audioData.cover}
                onCoverChange={setCoverImage}
              />
            )}
          </Form.Item>
          <Form.Item
            required={false}
            colon={false}
            label={
              discussionRoomType === 'stories'
                ? t('v4:stories_modal.lbl_title')
                : t('v4:audio_modal.lbl_title')
            }
          >
            {getFieldDecorator('title', {
              initialValue: audioData.title || '',
              rules: [
                {
                  required: true,
                  message:
                    discussionRoomType === 'stories'
                      ? t('v4:stories_modal.rule_title')
                      : t('v4:audio_modal.rule_title')
                }
              ]
            })(<Input />)}
          </Form.Item>
          <Form.Item
            required={false}
            colon={false}
            label={
              discussionRoomType === 'stories'
                ? t('v4:stories_modal.lbl_description')
                : t('v4:audio_modal.lbl_description')
            }
          >
            {getFieldDecorator('description', {
              initialValue: audioData.description || '',
              rules: [
                {
                  required: true,
                  message:
                    discussionRoomType === 'stories'
                      ? t('v4:stories_modal.rule_description')
                      : t('v4:audio_modal.rule_description')
                }
              ]
            })(
              <TextEditor
                value={audioData.description}
                onChange={data => {
                  setFieldsValue({ description: data })
                  setEditorDescription(data)
                }}
              />
            )}
          </Form.Item>
          <Form.Item
            required={false}
            colon={false}
            label={
              discussionRoomType === 'stories'
                ? t('v4:stories_modal.lbl_file')
                : t('v4:audio_modal.lbl_file')
            }
          >
            {getFieldDecorator('files', {
              initialValue: fileList.length > 0 ? fileList : [],
              rules: [
                {
                  validator: (rule, value, callback) => {
                    // Check if fileList has items
                    if (fileList.length === 0) {
                      callback(
                        discussionRoomType === 'stories'
                          ? t('v4:stories_modal.rule_file')
                          : t('v4:audio_modal.rule_file')
                      )
                    } else {
                      callback()
                    }
                  }
                }
              ],
              getValueFromEvent: e => {
                // Handle both direct file selection and library selection
                if (Array.isArray(e)) {
                  return e
                }
                return e && e.fileList
              }
            })(
              <Row type="flex" align="middle">
                <Upload {...uploadProps} accept=".mp3" listType="text">
                  {fileList.length === 0 && (
                    <Button>
                      <UploadOutlined />
                      {discussionRoomType === 'stories'
                        ? t('v4:stories_modal.lbl_select_file')
                        : t('v4:audio_modal.lbl_select_file')}
                    </Button>
                  )}
                </Upload>
                {fileList.length === 0 && (
                  <>
                    &nbsp; or &nbsp;
                    <Button
                      onClick={() => {
                        setLibrayModal(true)
                      }}
                    >
                      {t('buttons:select_media_library')}
                    </Button>
                  </>
                )}
              </Row>
            )}
          </Form.Item>
        </Fragment>
      </Form>
      <Modal
        visible={libraryModal}
        onCancel={() => {
          setLibrayModal(false)
        }}
        footer={null}
        width={'80%'}
        centered
      >
        <div className="wrap_modal_tabs">
          <PopupMedia
            isPageBuilder
            handleInsertData={handleInsertData}
            types="AUDIO"
          />
        </div>
      </Modal>
    </Modal>
  )
}

export default Form.create({ name: 'podcast_form' })(UploadAudioModal)
